:host {
  display: flex;
  flex-direction: column;

  gap: 8px;
  padding: 0px 16px;
  box-sizing: border-box;
  width: 100%;
}
